import { Form } from "antd";

const Venues = () => {
  return (
    <>
      <Form.Item>
        <p>Coupon will be applied to this entire event</p>
      </Form.Item>
    </>
  );
};

export default Venues;
